import { useMemo, useState } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
// import Label from 'src/components/label';
// import Iconify from 'src/components/iconify';
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { useBoolean } from 'src/hooks/use-boolean';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
  // OR
  // <Iconify icon="fluent:mail-24-filled" />
  // https://icon-sets.iconify.design/solar/
  // https://www.streamlinehq.com/icons
);

const ICONS = {
  job: icon('ic_job'),
  resturant: icon('ic_plate'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
  badge: icon('ic_badge'),
  category: icon('ic_category'),
  language: icon('ic_language'),
  practice: icon('ic_practice'),
  culture: icon('ic_culture'),
  subscription: icon('ic_subscription'),
  screen: icon('ic_screen'),
  helperSection: icon('ic_help'),
  qna: icon('ic_qna'),
  faq: icon('ic_faq'),
  tac: icon('ic_tac'),
  privacy: icon('ic_privacy')
};

// ----------------------------------------------------------------------

export function useNavData() {

  const { t } = useLocales();

  const { user } = useMockedUser();

    const newFolder = useBoolean();


  const handleOpenModal = () => {newFolder.onTrue() };

  const data = useMemo(
    () => [
      // OVERVIEW
      // ----------------------------------------------------------------------
      {
        subheader: 'overview',

        items: [
          ...(user?.user_type === "3" || user?.user_type === "4"
            ? [
              // {
              //   title: "Dashboard",
              //   path: paths.dashboard.root,
              //   icon: ICONS.dashboard,
              // },
              {
                title: "File",
                path: paths.dashboard.file,
                icon: ICONS.file,
              },
               {
                title: "Upload New Image / Video",
                path: '#',
                icon: ICONS.folder,
                onClick: handleOpenModal, 
              },
            ]
            : []),

          ...(user?.user_type === "2"
            ? [
              {
                title: "Dashboard",
                path: paths.adminDashboard.root,
                icon: ICONS.dashboard,
              },
              {
                title: "File",
                path: paths.adminDashboard.file,
                icon: ICONS.file,
              },
              {
                title: "Upload New Image / Video",
                path: '#',
                icon: ICONS.folder,
                onClick: handleOpenModal, 
              },
              {
                title: "Users",
                path: paths.adminDashboard.user,
                icon: ICONS.user,
              },
              {
                title: "Category",
                path: paths.adminDashboard.category,
                icon: ICONS.category,
              },
              {
                title: "Banner",
                path: paths.adminDashboard.banner,
                icon: ICONS.badge,
              }
            ]
            : []),

          ...(user?.user_type === "1"
            ? [
              {
                title: "Dashboard",
                path: paths.superAdminDashboard.root,
                icon: ICONS.dashboard,
              },
              {
                title: "File",
                path: paths.superAdminDashboard.file,
                icon: ICONS.file,
              },
              {
                title: "Upload New Image / Video",
                path: '#',
                icon: ICONS.folder,
                onClick: handleOpenModal, 
              },
              {
                title: "Users",
                path: paths.superAdminDashboard.user,
                icon: ICONS.user,
              },
              {
                title: "Category",
                path: paths.superAdminDashboard.category,
                icon: ICONS.category,
              },
              {
                title: "Banner",
                path: paths.superAdminDashboard.banner,
                icon: ICONS.badge,
              }
              // {
              //   title: "About Us",
              //   path: paths.superAdminDashboard.aboutUs,
              //   icon: ICONS.tour,
              // },
              // {
              //   title: "FAQs",
              //   path: paths.superAdminDashboard.faqs,
              //   icon: ICONS.faq,
              // },
              // {
              //   title: "Terms & Conditions",
              //   path: paths.superAdminDashboard.terms,
              //   icon: ICONS.tac,
              // },
              // {
              //   title: "Privacy Policy",
              //   path: paths.superAdminDashboard.privacy,
              //   icon: ICONS.privacy,
              // },
            ]
            : [])
        ],
      },
    ],
    [t]
  );

  return{ data, openModal: newFolder.value, handleCloseModal: newFolder.onFalse, handleOpenModal: handleOpenModal };
}
